import axios from "axios";

const API = process.env.REACT_APP_API_URL;

//  Send Contact Message
export const sendContactMessage = async (data) => {
  const res = await axios.post(`${API}/contact`, data);
  return res.data;
};